'use strict';

var React = require('react');

const useValidityState = ({ onValidityChange, getState }) => {
    const previousReason = React.useRef(null);
    React.useEffect(() => {
        const validityState = getState();
        if (!validityState)
            return;
        const validityStateKeys = Object.keys(validityState);
        const reason = validityStateKeys.find(key => validityState[key]) ?? null;
        const isValid = reason === null;
        const validityHasChanged = reason !== previousReason.current;
        if (validityHasChanged) {
            onValidityChange?.({ isValid, reason });
        }
        previousReason.current = reason;
    }, [getState, onValidityChange]);
};
const useElementValidityState = (states) => ({ value, required, elementRef, onValidityChange }) => {
    useValidityState({
        onValidityChange,
        getState: React.useCallback(() => {
            const validityState = elementRef.current?.validity;
            const entries = validityState ? states.map(state => [state, validityState[state]]) : [];
            return Object.fromEntries(entries);
        }, [value, required, states]),
    });
};

exports.useElementValidityState = useElementValidityState;
exports.useValidityState = useValidityState;
//# sourceMappingURL=useValidityState.js.map
